import React from 'react';
import {type MessageDescriptor} from 'react-intl';
import {DownloadCsvButton} from '@igp/shared/components/download';
import type {UseDownloadProps, UseDownloadResult} from '@igp/shared/redux/download';
import {useDownload} from '@igp/shared/redux/download';

import {agentLevelReportV2ServiceTypes} from '../constants';
import type {AgentLevelReportV2ViewModelsKeys} from '../types';

import {localized} from './DataGrid';

type UseAgentLevelReportV2DownloadProps = Pick<
    UseDownloadProps<AgentLevelReportV2ViewModelsKeys>,
    'filename' | 'keys' | 'mode' | 'filter' | 'total'
>;

export function useAgentLevelReportV2Download(props: UseAgentLevelReportV2DownloadProps): UseDownloadResult {
    const {handleDownload, isProgress} = useDownload<AgentLevelReportV2ViewModelsKeys>({
        ...props,
        strategySymbol:
            props.mode === 'client'
                ? agentLevelReportV2ServiceTypes.downloadClientStrategy
                : agentLevelReportV2ServiceTypes.downloadServerStrategy,
        headersLocalization: localized as Record<AgentLevelReportV2ViewModelsKeys, MessageDescriptor>,
    });

    return {handleDownload, isProgress};
}

export function AgentLevelReportV2DownloadCsvButton({disabled, ...props}: UseAgentLevelReportV2DownloadProps & {disabled: boolean}) {
    const {handleDownload, isProgress} = useAgentLevelReportV2Download(props);
    return <DownloadCsvButton onClick={handleDownload} loading={isProgress} disabled={isProgress || disabled} />;
}
